import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import sharedStyles from "../Input.module.css";
import styles from "./AddItemInput.module.css";

export default function AddItemInput({ inputProps, controlProps, slotProps, config = {} }) {
	const { items: controlledItems, defaultItems = [], lockedItems = [], onItemsChange, onAddItem } = config;
	const [internalItems, setInternalItems] = useState(defaultItems);
	const [draft, setDraft] = useState(inputProps.defaultValue ?? "");
	const items = controlledItems === undefined ? internalItems : controlledItems;
	const { onChange, onKeyDown, ...rest } = inputProps;
	const draftValue = draft;
	const locked = inputProps.disabled || inputProps.readOnly;
	const normalizedValue = draftValue.trim();

	function updateItems(nextItems) {
		if (controlledItems === undefined) {
			setInternalItems(nextItems);
		}
		onItemsChange?.(nextItems);
	}

	function handleAddItem(event) {
		event.preventDefault();
		if (!normalizedValue || locked) {
			return;
		}
		const parsedItems = normalizedValue.split(",").map((item) => item.trim()).filter(Boolean);
		if (parsedItems.length === 0) {
			return;
		}
		updateItems([...items, ...parsedItems]);
		onAddItem?.(parsedItems);
		setDraft("");
	}

	function handleInputChange(event) {
		setDraft(event.target.value);
		onChange?.(event);
	}

	function handleKeyDown(event) {
		onKeyDown?.(event);
		if (event.key === "Enter" && !event.defaultPrevented) {
			handleAddItem(event);
		}
	}

	return (
		<>
			<div {...slotProps("addItemRow", styles.addItemInputContainer)}>
				<div {...controlProps}>
					<input
						{...rest}
						type="text"
						defaultValue={undefined}
						value={draftValue}
						onChange={handleInputChange}
						onKeyDown={handleKeyDown}
						{...slotProps("field", sharedStyles.field)}
					/>
				</div>
				<button type="button" onClick={handleAddItem} disabled={locked || !normalizedValue}
					aria-label="Add item" {...slotProps("addButton", styles.addItemButton)}>
					<FiPlus size={24} aria-hidden="true" {...slotProps("addIcon", styles.addIcon)} />
				</button>
			</div>
			{items.length > 0 && (
				<div {...slotProps("itemList", styles.addItemList)}>
					{items.map((item, index) => (
						<span key={`${item}-${index}`} {...slotProps("item", styles.addItemChip)}>
							{item}
							{!lockedItems.includes(item) && (
								<button type="button" disabled={locked} aria-label={`Remove ${item}`}
									onClick={() => updateItems(items.filter((_, itemIndex) => itemIndex !== index))}
									{...slotProps("removeButton", styles.removeItemButton)}>
									<IoClose size={16} aria-hidden="true" {...slotProps("removeIcon", styles.removeIcon)} />
								</button>
							)}
						</span>
					))}
				</div>
			)}
		</>
	);
}
